import React, {Component} from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectNenshiki extends Component {

  handleChangeStart = (e) => {
    this.props.actions.changeSelectNenshikiStart({
      selectNenshikiStart: (e.target.value).split('nenshiki_').join(''),
    })
  }

  handleChangeFinish = (e) => {
    this.props.actions.changeSelectNenshikiFinish({
      selectNenshikiFinish: (e.target.value).split('nenshiki_').join(''),
    })
  }

  render() {
    const {  payload } = this.props.systemLabelMastersApi
    if (!payload) {return null}
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.NENSHIKI}</h3>
        <div className='searchArea__item__half searchArea__item__inner'>
          <p className='selectWrap'>
            <select
              className='select'
              value={'nenshiki_' + this.props.selectNenshikiStart}
              onChange={this.handleChangeStart}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.LOWER}</option>
              {
                systemLabelMasterCollection.getValueList('item','nenshiki').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')} >{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
          <p>〜</p>
          <p className='selectWrap'>
            <select
              className='select'
              value={'nenshiki_' + this.props.selectNenshikiFinish}
              onChange={this.handleChangeFinish}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.UPPER}</option>
              {
                systemLabelMasterCollection.getValueList('item','nenshiki').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')} >{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
        </div>
      </div>
    )
  }
}
export default SelectNenshiki
